import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const WordCounter = () => {
  const [text, setText] = useState('');
  const [stats, setStats] = useState({
    words: 0,
    charactersWithSpaces: 0,
    charactersWithoutSpaces: 0,
    sentences: 0,
    lines: 0
  });

  const analyzeText = (inputText) => {
    if (!inputText) {
      setStats({
        words: 0,
        charactersWithSpaces: 0,
        charactersWithoutSpaces: 0,
        sentences: 0,
        lines: 0
      });
      return;
    }

    // Words: split by whitespace and filter out empty strings
    const words = inputText.trim().split(/\s+/).filter(word => word.length > 0);
    
    // Characters
    const charactersWithSpaces = inputText.length;
    const charactersWithoutSpaces = inputText.replace(/\s/g, '').length;
    
    // Sentences: count by sentence-ending punctuation
    const sentences = inputText.split(/[.!?]+/).filter(s => s.trim().length > 0).length;
    
    // Lines: count by line breaks
    const lines = inputText.split(/\r?\n/).length;

    setStats({
      words: words.length,
      charactersWithSpaces,
      charactersWithoutSpaces,
      sentences,
      lines
    });
  };

  useEffect(() => {
    analyzeText(text);
  }, [text]);

  return (
    <div className="space-y-6">
      {/* Text Input */}
      <div>
        <label className="block text-white font-medium mb-2">
          Text eingeben
        </label>
        <textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Geben Sie hier Ihren Text ein..."
          rows={10}
          className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-purple-400 resize-vertical"
        />
      </div>

      {/* Statistics */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white/5 rounded-xl p-6 border border-white/10"
      >
        <h3 className="text-2xl font-bold text-white mb-6 text-center">
          Textstatistiken
        </h3>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          <div className="text-center">
            <div className="text-3xl font-bold text-purple-300">{stats.words.toLocaleString()}</div>
            <div className="text-white/70 text-sm">Wörter</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-purple-300">{stats.charactersWithSpaces.toLocaleString()}</div>
            <div className="text-white/70 text-sm">Zeichen (mit Leerzeichen)</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-purple-300">{stats.charactersWithoutSpaces.toLocaleString()}</div>
            <div className="text-white/70 text-sm">Zeichen (ohne Leerzeichen)</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-purple-300">{stats.sentences.toLocaleString()}</div>
            <div className="text-white/70 text-sm">Sätze</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-purple-300">{stats.lines.toLocaleString()}</div>
            <div className="text-white/70 text-sm">Zeilen</div>
          </div>
        </div>

        {text && (
          <div className="mt-6 pt-4 border-t border-white/10">
            <h4 className="text-lg font-semibold text-white mb-3">Zusätzliche Informationen</h4>
            <div className="grid md:grid-cols-2 gap-4 text-sm">
              <div className="flex justify-between">
                <span className="text-white/70">Durchschnittliche Wortlänge:</span>
                <span className="text-white font-medium">
                  {stats.words > 0 ? (stats.charactersWithoutSpaces / stats.words).toFixed(1) : 0} Zeichen
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-white/70">Durchschnittliche Satzlänge:</span>
                <span className="text-white font-medium">
                  {stats.sentences > 0 ? (stats.words / stats.sentences).toFixed(1) : 0} Wörter
                </span>
              </div>
            </div>
          </div>
        )}
      </motion.div>
    </div>
  );
};

export default WordCounter;